import React from 'react';
import { QuadrantItem } from './QuadrantItem';
import { Col } from 'reactstrap';
import {
    QUADRANTS_ANALYTIC, QUADRANTS_INNOVATIVE, QUADRANTS_RELATIONAL,
    QUADRANTS_PROCEDURAL, QUADRANTS_ALL
} from '../../../core/constants';
import graphic_report from '../../../assets/img/chart-280.svg';

export const QuadrantList = ({ toggle, user }) => {

    return (
        <>
            <div id="lists-top" className="d-flex list-top justify-content-between align-items-end row position-relative">
                <div className="col-6 cursor-pointer align-items-md-end d-md-flex justify-content-md-end" onClick={(e) => {e.stopPropagation();toggle(QUADRANTS_ANALYTIC)}}>
                    <div className="lists-item mx-0 text-right pr-lg-3">
                        {
                            user.talents &&
                            user.talents?.map(quadrant =>
                                quadrant.quadrant === 'Analytic' &&
                                quadrant.items?.map(item =>
                                    <QuadrantItem
                                        key={'_qitem_' + item.id}
                                        item={item}
                                        quadrant={quadrant}
                                    />
                                )
                            )
                        }
                    </div>
                </div>
                <Col xs={{ size: 6 }} className="cursor-pointer align-items-md-end d-md-flex" onClick={(e) => {e.stopPropagation();toggle(QUADRANTS_INNOVATIVE)}}>
                    <div className="lists-item">
                        {
                            user.talents &&
                            user.talents?.map(quadrant =>
                                quadrant.quadrant === 'Innovative' &&
                                quadrant.items?.map(item =>
                                    <QuadrantItem
                                        key={'qitem_' + item.id}
                                        item={item}
                                        quadrant={quadrant}
                                    />
                                )
                            )
                        }
                    </div>
                </Col>
            </div>

            <div className="bg-map-dk mx-auto">
                <div className="graphic-map-img mx-auto" style={{ width: '280px' }}>
                    <div className="mx-auto text-center graphic-list-all-talent">
                        <div>
                            {
                                user.talents &&
                                user.talents?.map(quadrant =>
                                    quadrant.quadrant === 'All' && quadrant.items?.map(item =>
                                        <QuadrantItem
                                            key={'qitem_' + item.id}
                                            item={item}
                                            quadrant={quadrant}
                                        />
                                    )
                                )
                            }
                        </div>
                    </div>
                    <img alt="user map" src={graphic_report} useMap={`#image_map_${user.id}`} id={user.id} className="img-fluid" style={{ opacity: 0 }} />
                    <map name={`image_map_${user.id}`} id={user.id}>
                        <area onClick={(e) => {e.stopPropagation();toggle(QUADRANTS_ANALYTIC)}} alt="Analytic" title="Analytic" coords="0,140,5,103,20,70,35,48,62,23,89,9,114,2,138,0,140,50,114,54,90,64,69,82,55,108,47,142" shape="poly" />
                        <area onClick={(e) => {e.stopPropagation();toggle(QUADRANTS_INNOVATIVE)}} alt="Innovative" title="Innovative" coords="140,50,141,0,172,4,193,10,216,23,236,39,253,57,264,77,274,99,279,115,280,141,232,141,229,111,217,89,196,67,167,52" shape="poly" />
                        <area onClick={(e) => {e.stopPropagation();toggle(QUADRANTS_RELATIONAL)}} alt="Relational" title="Relational" coords="230,141,280,141,276,174,267,203,254,223,236,242,215,258,180,276,141,279,142,232,167,227,195,214,215,194,229,162,230,141" shape="poly" />
                        <area onClick={(e) => {e.stopPropagation();toggle(QUADRANTS_PROCEDURAL)}} alt="Procedural" title="Procedural" coords="0,139,49,143,53,168,63,188,76,205,97,219,119,230,140,230,141,279,108,279,80,267,57,254,39,237,18,214,6,183" shape="poly" />
                        <area onClick={(e) => {e.stopPropagation();toggle(QUADRANTS_ALL)}} alt="All" title="All" coords="139,141,91" shape="circle" />
                    </map>
                </div>
            </div>

            <div id="lists-bottom" className="d-flex list-bottom justify-content-between align-items-start row position-relative">
                <div className="col-6 cursor-pointer align-items-md-start d-md-flex justify-content-md-end" onClick={(e) => {e.stopPropagation();toggle(QUADRANTS_PROCEDURAL)}}>
                    <div className="lists-item mx-0 text-right pr-lg-3">
                        {
                            user.talents &&
                            user.talents?.map(quadrant =>
                                quadrant.quadrant === 'Procedural' &&
                                quadrant.items?.map(item =>
                                    <QuadrantItem
                                        key={'qitem_' + item.id}
                                        item={item}
                                        quadrant={quadrant}
                                    />
                                )
                            )
                        }
                    </div>
                </div>
                <Col xs={{ size: 6 }} className="cursor-pointer align-items-md-start d-md-flex" onClick={(e) => {e.stopPropagation();toggle(QUADRANTS_RELATIONAL)}}>
                    <div className="lists-item">
                        {
                            user.talents &&
                            user.talents?.map(quadrant =>
                                quadrant.quadrant === 'Relational' &&
                                quadrant.items?.map(item =>
                                    <QuadrantItem
                                        key={'qitem_' + item.id}
                                        item={item}
                                        quadrant={quadrant}
                                    />
                                )
                            )
                        }
                    </div>
                </Col>
            </div>

        </>
    )
}
